var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('InputElement',{attrs:{"label":_vm.label,"prepend-inner-icon":"mdi-magnify"},on:{"input":_vm.handleSearchInput},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }